module.exports = __webpack_public_path__ + "img/image-douglas-hurley.d812b585.png";